import React from 'react';
import PhotoOnLeft from "../../components/PhotoOnLeft";
import Heading from "../../atoms/Heading";
import { styled } from "../../../stitches.config";

import { ExitScreenLayoutProps } from "./ExitScreenLayoutTypes";

const ExitScreenDefaultLayout: React.FC<ExitScreenLayoutProps> = ({ posts }) => {

    return (
        <Container className="container">
            <Heading title={"Zobacz również"} />
            {posts.map(post => (
                <PhotoOnLeft
                    boxSize="xs"
                    article={post}
                    dataAnalyticsName={"article-from-exitScreen"}
                />
            ))}
        </Container>
    );

};

export default ExitScreenDefaultLayout;

const Container = styled('div', {
    marginTop: '40px'
});